import React from 'react'
import styled from 'styled-components'
import { useLastItemRef } from '../../../hooks/useLastItemRef'
import noItemsImg from '../assets/noitems.svg'

const NoItemsFoundContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  color: #c4c4c4;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;

  @media screen and (max-width: 480px) {
    padding: 0;
  }
`

const NoItemsImage = styled.img`
  width: 467px;
  height: 303px;
  margin-top: 75px;

  @media screen and (max-width: 480px) {
    width: 70vw;
    height: auto;
  }
`

const NoItemsText = styled.p`
  padding-top: 33px;
  text-align: center;
  font-weight: 500;
  font-size: 18px;
  text-align: center;
  letter-spacing: 0.01em;
  color: #8b8b8b;
`

const DesignFeed = ({
  data,
  onFetch,
  onClick,
  card,
  loading,
  error,
  ...props
}) => {
  const lastFeedItem = useLastItemRef(onFetch)

  if (!data) return <></>

  if (data && data.length === 0 && error === 'empty') {
    return (
      <NoItemsFoundContainer>
        <NoItemsImage src={noItemsImg} alt="" />
        <NoItemsText>No design yet</NoItemsText>
      </NoItemsFoundContainer>
    )
  }

  return (
    <>
      {data.map((item, index) => {
        const Card = card
        return (
          <Card
            key={index}
            data={item}
            refFn={lastFeedItem}
            onClick={onClick}
            {...props}
          />
        )
      })}
    </>
  )
}

export default DesignFeed
